<div class="user-balances" [ngClass]="{ 'kids-balance': isKid }">
  <!--Points Balance-->
  <div class="balance-widget" [ngClass]="{ 'kids-balance-points': isKid }">
    <div class="balance-details">
      <span class="icon material-icons">loyalty</span>
      <div class="balance">
        <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
        <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
      </div>
    </div>
  </div>

  <!--eCash Balance-->
  <ng-container *notInPopulation="population.Kids">
    <div class="balance-widget cursor-pointer" [routerLink]="'/hawksbucks'">
      <div class="balance-details">
        <span class="icon material-icons material-symbols-outlined money-bag-icon">money_bag</span>
        <div class="balance">
          <h5 class="mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</h5>
          <div class="font-size-12 me-1">{{ 'member.card.ecash.balance' | translate }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
